import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const
const locationCredentialTypes = ['customer-id'] as const

export type wardCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const wardDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
  'weight-and-research-inspection',
] as const satisfies readonly DocumentType[]

export const ward: CarrierDef<wardCredType> = {
  name: 'Ward Transport & Logistics',
  scac: 'ward',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    { id: 'volume', name: 'Volume' },
    {
      id: 'guaranteed_before_twelve_pm',
      name: 'Guaranteed before noon',
      guaranteed: true,
      guaranteedByTime: '12:00',
    },
    {
      id: 'guaranteed_before_three_pm',
      name: 'Guaranteed before 3PM',
      guaranteed: true,
      guaranteedByTime: '15:00',
    },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [...userPassMap, ['customer-id', 'ref1']],
  engineLayers: [
    'rating',
    'bol',
    'pickup',
    'profinder',
    'documents',
    'tracking',
  ],
  documentTypes: wardDocumentTypes,
  credentialConfig: {
    'customer-id': { customerIdentifier: true },
  },
}
